import * as React from 'react';
import { ApolloError, gql } from '@apollo/client';
import { useGetOrganizationLazyQuery } from '../../../models/graphql';
import { TeamManagementController, TeamManagementControllerProps } from './TeamManagement.controller';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

export type TeamManagementApolloProps = Omit<
  TeamManagementControllerProps,
  'getOrganization' | 'organizationResults' | 'mappedError'
> & {
  // ...
};

gql`
  query GetOrganization($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      userAssignments {
        id
        role
        user {
          id
          firstName
          email
        }
      }
      userInvitations {
        id
        email
        role
        workspaceIds
        token
      }
      workspaces {
        id
        name
        timezone
        users {
          id
          firstName
        }
        socialProfiles {
          id
          connected
          photoUrl
          displayName
          onboardingContent
          workspace {
            id
          }
        }
      }
    }
  }
`;

export const TeamManagementApollo = (props: TeamManagementApolloProps): JSX.Element => {
  let mappedError: string | JSX.Element = '';

  const [getOrganization, organizationResults] = useGetOrganizationLazyQuery();

  if (organizationResults.error) {
    const errorForRemapping = organizationResults.error as ApolloError;
    mappedError = remapApolloErrors(errorForRemapping);
  }

  const controllerProps: TeamManagementControllerProps = {
    ...props,
    getOrganization,
    organizationResults,
    mappedError
  };

  return <TeamManagementController {...controllerProps} />;
};
